<template>
  <div class="no-print mb-6">
    <h2>Stripe Payments</h2>

    <StripePaymentDetailModal
      v-if="selectedPayment"
      :show="!!selectedPayment"
      :order-number="Number(selectedPayment.orderNumber)"
      :payment-intent-id="selectedPayment.paymentIntentId"
      :return-id="returnId"
      :return-refundable="returnRefundable"
      @close="selectedPayment = null"
      @refunded="$emit('refunded', $event)"
    />

    <div v-if="loading" class="py-2">
      <BaseMiniSpinner />
    </div>
    <div v-else-if="loadError" class="text-red-600 text-base">
      {{ loadError }}
      <button class="underline ml-2" @click="loadPayments">Retry</button>
    </div>
    <p v-else-if="payments.length === 0" class="text-gray-500 text-base">
      This order has no Stripe payments.
    </p>
    <div v-else class="space-y-2">
      <div
        v-for="payment in payments"
        :key="`${payment.orderNumber}-${payment.paymentIntentId}`"
        class="flex justify-between items-center bg-gray-50 border border-gray-200 rounded-lg p-3"
      >
        <div class="text-base">
          <div class="font-mono">{{ payment.paymentIntentId }}</div>
          <div class="text-gray-600">
            ${{ Number(payment.amount).toFixed(2) }} ·
            {{ formatDateWithHour(payment.date) }}
            <template
              v-if="String(payment.orderNumber) !== String(orderNumber)"
            >
              · parent order #{{ payment.orderNumber }}
            </template>
          </div>
        </div>
        <button
          class="btn-dark-button whitespace-nowrap"
          @click="selectedPayment = payment"
        >
          View / Refund
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { formatDateWithHour } from "@/helpers/globalHelpers.js";
import { getOrderStripePayments } from "@/api/store/StripeRefundsService.js";
import StripePaymentDetailModal from "@/components/order/StripePaymentDetailModal.vue";

export default {
  components: { StripePaymentDetailModal },
  props: {
    returnId: { type: String, required: true },
    orderNumber: { type: [String, Number], required: true },
    returnRefundable: { type: Number, required: false, default: null }
  },
  data() {
    return {
      loading: false,
      loadError: null,
      payments: [],
      selectedPayment: null
    };
  },
  computed: {
    canRefund() {
      return this.$store.getters["auth/userHasPermission"](
        "can_refund_payment"
      );
    }
  },
  mounted() {
    this.loadPayments();
  },
  methods: {
    formatDateWithHour,
    async loadPayments() {
      this.loading = true;
      this.loadError = null;
      try {
        const result = await getOrderStripePayments(
          this.$store.getters["auth/currentToken"],
          this.orderNumber
        );
        this.payments = result.payments;
      } catch (err) {
        this.loadError = err.response?.data?.error ?? err.message;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
